import React from 'react';
import { IMainLayoutDomainStore } from './IMainLayoutDomainStore';

export const LayoutDomainContext = React.createContext<IMainLayoutDomainStore | null>(null);

export const useLayoutDomain = (): IMainLayoutDomainStore => {
  const ctx = React.useContext(LayoutDomainContext);
  if (!ctx) {
    throw new Error('useLayoutDomain must be used inside <LayoutDomainContext.Provider>');
  }
  return ctx;
};